import { render, staticRenderFns } from "./SimpleChart.vue?vue&type=template&id=a0a3b8cc&scoped=true&"
import script from "./SimpleChart.vue?vue&type=script&lang=ts&"
export * from "./SimpleChart.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleChart.vue?vue&type=style&index=0&id=a0a3b8cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a3b8cc",
  null
  
)

export default component.exports